import {validate as clientProductValidate} from './validatorClientProduct';

const validate = (values, props) => {
    let errors = {};

    Object.assign(errors, clientProductValidate(values, props));

    return errors;
};

export default validate;
